import { DS_FONT_FAMILY, DS_FONT_WEIGHT } from '@calm/evexia-design-tokens';
import { SvgIcon, SvgIconProps } from '@rhg/libs/material';
import { formatPlaybackRate } from '@rhg/utils/media';

export interface SpeedGlyphProps extends SvgIconProps {
    /** The playback rate to display, e.g. 1.5 -> "1.5". */
    rate: number;
}

/**
 * The playback-speed glyph: the speed number with small bars beneath it.
 * Uses fontSize because we are in SVGland instead of HTML
 */
export function SpeedGlyph({ rate, ...props }: SpeedGlyphProps) {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <text
                x="12"
                y="11"
                textAnchor="middle"
                dominantBaseline="middle"
                fontSize="14"
                fontWeight={DS_FONT_WEIGHT.ULTRA_BOLD}
                fontFamily={DS_FONT_FAMILY}
                fill="currentColor"
            >
                {formatPlaybackRate(rate)}
            </text>
            <path
                d="M7.85556 16.7939H2.36252C2.14505 16.7939 1.96875 16.9702 1.96875 17.1877V18.3395C1.96875 18.5569 2.14504 18.7332 2.36252 18.7332H7.85556C8.07303 18.7332 8.24932 18.5569 8.24932 18.3395V17.1877C8.24932 16.9702 8.07303 16.7939 7.85556 16.7939Z"
                fill="currentColor"
            />
            <path
                d="M13.4967 16.7939H9.65744C9.43997 16.7939 9.26367 16.9702 9.26367 17.1877V18.3395C9.26367 18.5569 9.43997 18.7332 9.65744 18.7332H13.4967C13.7141 18.7332 13.8904 18.5569 13.8904 18.3395V17.1877C13.8904 16.9702 13.7141 16.7939 13.4967 16.7939Z"
                fill="currentColor"
            />
            <path
                d="M18.271 16.7939H15.2981C15.0806 16.7939 14.9043 16.9702 14.9043 17.1877V18.3395C14.9043 18.5569 15.0806 18.7332 15.2981 18.7332H18.271C18.4885 18.7332 18.6648 18.5569 18.6648 18.3395V17.1877C18.6648 16.9702 18.4885 16.7939 18.271 16.7939Z"
                fill="currentColor"
            />
            <path
                d="M21.0962 16.7939H20.0822C19.8648 16.7939 19.6885 16.9702 19.6885 17.1877V18.3395C19.6885 18.5569 19.8648 18.7332 20.0822 18.7332H21.0962C21.3137 18.7332 21.49 18.5569 21.49 18.3395V17.1877C21.49 16.9702 21.3137 16.7939 21.0962 16.7939Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
}
